export default class VisitsTracker {
  constructor() {
    this.key = "last_visit";
    this.companiesKey = "last_visit_companies";
    const today = new Date().toISOString().slice(0, 10);

    if (this.shouldTrack(today)) {
      this.track(today);
    }
    this.trackLanguageChanges();
  }

  trackLanguageChanges() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "attributes") {
          const today = new Date().toISOString().slice(0, 10);
          this.track(today);
        }
      });
    });

    observer.observe(document.body.parentElement, {
      attributeFilter: ["lang"],
    });
  }

  getCompanies() {
    let companies = localStorage.getItem(this.companiesKey);
    return companies === null ? [] : JSON.parse(companies);
  }

  track(today) {
    let data = {
      lang: document.body.parentElement.lang,
    };
    let companies = this.getCompanies();

    if (window.currentCompany) {
      data.company = window.currentCompany.id;
      companies.push(data.company);
    }

    peque.api("visits", data, "post");
    localStorage.setItem(this.key, today);
    localStorage.setItem(this.companiesKey, JSON.stringify(companies));
  }

  shouldTrack(today) {
    if (typeof window.currentUser === "undefined") {
      return false;
    }
    const lastVisit = localStorage.getItem(this.key);
    const isNewDay = lastVisit !== today;
    const companies = this.getCompanies();

    if (isNewDay) {
      // reset the companies
      localStorage.removeItem(this.companiesKey);
    }

    return (
      isNewDay ||
      (window.currentCompany && !companies.includes(window.currentCompany.id))
    );
  }
}

window.VisitsTracker = VisitsTracker;
